<template>
    <div :key="key">
        <b-input
            ref="document"
            v-model="form.document"
            size="sm"
            :class="reactiveClass"
            @change="savePoint"
        />
    </div>
</template>

<script>
import TableFormHandler from '../../../../../common/mixins/TableFormHandler'

export default {
    name: 'DocumentForm',

    mixins: [TableFormHandler],

    props: {
        point: {},
    },

    created() {
        this.align = 'left'
    },

    methods: {
        async savePoint() {
            try {
                await axios.put(
                    `/pendingPoints/${this.point.id}/document`,
                    this.form
                )
                this.handleSuccess()
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },

        initForm() {
            this.form.document = this.point.document
        },

        setInitialKey() {
            this.key = `document${this.point.id}`
        },

        unFocus() {
            this.$refs.document.blur()
        },
    },
}
</script>

<style scoped>
.form-control-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}
</style>
